import { render, staticRenderFns } from "./SaleBillingHistory.vue?vue&type=template&id=1f015a34&scoped=true&"
import script from "./SaleBillingHistory.vue?vue&type=script&lang=js&"
export * from "./SaleBillingHistory.vue?vue&type=script&lang=js&"
import style0 from "./SaleBillingHistory.vue?vue&type=style&index=0&id=1f015a34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f015a34",
  null
  
)

export default component.exports